import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";
import { MmCheckbox } from "@mm/zeus-react";
type AviationShowTimedOutProps = {
  showTimedOut: boolean;
  change: () => void;
};

export const AviationShowTimedOutCheckbox: React.FC<AviationShowTimedOutProps> = ({
  change,
  showTimedOut,
}: AviationShowTimedOutProps) => {
  return (
    <>
      <FormField label={t`Show Timed Out`}>
        <MmCheckbox
          cid={"show-timed-out"}
          data-testid="show-timed-out"
          value={"show-timed-out"}
          checked={showTimedOut}
          toggleHandler={change}
        />
      </FormField>
    </>
  );
};
